import { DocumentCheckIcon, DocumentTextIcon } from '@heroicons/react/24/outline';
import type { Asset, FileCategoryConfig } from '@odo/shared-ui';

const AGREEMENTS = 'Agreements';
const OTHER_DOCUMENTS = 'Other documents';

/**
 * Practice documents have their own two-way split (agreement/other) rather
 * than the patient files module's extension-based taxonomy (Images, Videos,
 * Documents, ...) - this overrides the "By category" grouping via the
 * module's `categoryConfig` seam. Per-file behavior (preview type, icons,
 * thumbnails) still comes from the module's own extension sniffing, which is
 * unaffected by this override (see fileTypes.categorizeAsset).
 */
export const PRACTICE_FILE_CATEGORY_CONFIG: FileCategoryConfig = {
    order: [AGREEMENTS, OTHER_DOCUMENTS],
    categorize: (asset: Asset) =>
        asset.storageCategory === 'agreement' ? AGREEMENTS : OTHER_DOCUMENTS,
    icons: {
        [AGREEMENTS]: <DocumentCheckIcon className="w-4 h-4" />,
        [OTHER_DOCUMENTS]: <DocumentTextIcon className="w-4 h-4" />
    }
};
